export interface GenreCategory {
  name: string;
  icon: string;
  description: string;
}

export const genreCategories: GenreCategory[] = [
  {
    name: "剧情",
    icon: "ri-film-line",
    description: "以人物与情感为核心，讲述日常里的转折",
  },
  {
    name: "爱情",
    icon: "ri-heart-3-line",
    description: "关于靠近与错过，克制而绵长的关系",
  },
  {
    name: "悬疑",
    icon: "ri-search-eye-line",
    description: "在城市夜色中寻找没有说完的答案",
  },
  {
    name: "文艺",
    icon: "ri-leaf-line",
    description: "缓慢的镜头，安静的情绪与光影",
  },
  {
    name: "纪录",
    icon: "ri-camera-lens-line",
    description: "真实生活里被认真保存的细节",
  },
  {
    name: "动作",
    icon: "ri-flashlight-line",
    description: "节制的力量感与人物之间的羁绊",
  },
];

export const yearFilters = [
  { label: "全部年份", value: "all" },
  { label: "2022 年", value: "2022" },
  { label: "2021 年", value: "2021" },
  { label: "2020 年", value: "2020" },
  { label: "2018 - 2019 年", value: "2018-2019" },
  { label: "2016 - 2017 年", value: "2016-2017" },
  { label: "2014 - 2015 年", value: "2014-2015" },
  { label: "2011 - 2013 年", value: "2011-2013" },
];